export * from './expanded-chart-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/tablero-negocios/expanded-chart-dialog/index.ts